import { TransactionKind, TransactionPayloadType } from 'storeTypes'

export const isSupportedTransaction = (transaction: TransactionPayloadType) => {
    return Object.values(TransactionKind).includes(
        transaction.type as TransactionKind
    )
}
